import { api } from "./client";
import type { Campaign, Contact } from "../types";

export interface ListCampaignsParams {
  q?: string;
  status?: string;
  campaign_type?: string;
  limit?: number;
  offset?: number;
  [key: string]: unknown;
}

export const campaignsApi = {
  list: (params: ListCampaignsParams = {}) =>
    api.get<Campaign[]>("/api/v1/campaigns", params),
  get: (id: string) => api.get<Campaign>(`/api/v1/campaigns/${id}`),
  getBySlug: (slug: string) =>
    api.get<Campaign>(`/api/v1/campaigns/slug/${slug}`),
  enroll: (campaignSlug: string, contactId: string, patch: Record<string, unknown> = {}) =>
    api.put<Contact>(
      `/api/v1/contacts/${contactId}/memberships/${campaignSlug}`,
      { patch: { status: "active", ...patch } },
    ),
  unenroll: (campaignSlug: string, contactId: string) =>
    api.delete<Contact>(
      `/api/v1/contacts/${contactId}/memberships/${campaignSlug}`,
    ),
};
